import React from "react";

type FreeShippingProgressBarProps = {
  current: number;
  max: number;
};

const FreeShippingProgressBar: React.FC<FreeShippingProgressBarProps> = ({
  current,
  max,
}) => {
  const progress = Math.min((current / max) * 100, 100);
  const remaining = max - current;
  const isFreeShipping = current >= max;

  return (
    <div style={styles.container}>
      <div style={styles.progressBarBackground}>
        <div style={{ ...styles.progressBarFill, width: `${progress}%` }}></div>
      </div>
      <p style={styles.progressText}>
        {isFreeShipping
          ? "Free Shipping Reached!"
          : `Only $${remaining.toFixed(2)} to go to receive free shipping`}
      </p>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    width: "100%",
    maxWidth: "400px",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyItems: "center",
  },
  progressBarBackground: {
    width: "100%",
    background: "#e0e0e0",
    borderRadius: "8px",
    height: "8px",
    overflow: "hidden",
  },
  progressBarFill: {
    height: "100%",
    background: "#4caf50",
    transition: "width 0.3s ease-in-out",
    borderRadius: "8px",
  },
  progressText: {
    marginTop: "8px",
    fontSize: "14px",
    fontWeight: "600",
    color: "#555",
    textAlign: "center",
  },
};

export default FreeShippingProgressBar;
